import { render, staticRenderFns } from "./settingsInformationAccounting.vue?vue&type=template&id=d94a26f2&scoped=true&"
import script from "./settingsInformationAccounting.vue?vue&type=script&lang=js&"
export * from "./settingsInformationAccounting.vue?vue&type=script&lang=js&"
import style0 from "./settingsInformationAccounting.vue?vue&type=style&index=0&id=d94a26f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94a26f2",
  null
  
)

export default component.exports